import React from 'react'
import { Paper } from '@material-ui/core'
import PropTypes from 'prop-types'

const Section = ({ height, style, className, children, elevation, radius }) => {
  return (
    <Paper
      style={{
        borderRadius: radius,
        backgroundColor: '#ffffff !important',
        minHeight: height,
        ...style,
      }}
      elevation={elevation}
      className={className}
    >
      {children}
    </Paper>
  )
}

Section.propTypes = {
  elevation: PropTypes.number,
  radius: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.any,
}

Section.defaultProps = {
  elevation: 0,
  radius: 5,
}

export default Section
